import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EvaluationTypeModal from '../EvaluationTypeModal';
import CalculatorModal from '../CalculatorModal';

const Footer = () => {
    const [showEvaluationModal, setShowEvaluationModal] = useState(false);
    const [showCalculatorModal, setShowCalculatorModal] = useState(false);
    const navigate = useNavigate();

    const handleSelectEvaluationType = (type) => {
        if (type === 'lecturers') {

            navigate('/lecturer-evaluation');
        } else if (type === 'courses') {

            navigate('/course-evaluation');
        }
        setShowEvaluationModal(false);
    };

    const handleSelectCalculatorType = (type) => {

        navigate(`/calculator?type=${type}`);
    };

    return (
        <>
            <EvaluationTypeModal
                isOpen={showEvaluationModal}
                onClose={() => setShowEvaluationModal(false)}
                onSelectEvaluationType={handleSelectEvaluationType}
            />

            <CalculatorModal
                isOpen={showCalculatorModal}
                onClose={() => setShowCalculatorModal(false)}
                onSelectCalculatorType={handleSelectCalculatorType}
            />

            <footer dir="rtl" className="bg-transparent text-white py-8 md:py-12">
                <div className="max-w-7xl mx-auto px-4 md:px-6">
                    {                                }
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-8">
                        {                                            }
                        <div className="col-span-1 text-center md:text-right">
                            <div className="flex justify-center md:justify-start items-center mb-4">
                                <img src="/images/HemaLogo.png" alt="Hemma Logo" className="h-[30px] md:h-[25px] w-auto" />
                            </div>
                            <p className="text-xs md:text-sm text-gray-300 mb-4 md:mb-6 leading-5 md:leading-6 max-w-xs md:max-w-none mx-auto md:mx-0">
                                موقع مخصص لطلاب وطالبات جامعة جدة يساعدهم في رحلتهم الدراسية منذ 2020
                            </p>
                            <button
                                type="button"
                                  onClick={() => window.open('https://x.com/Hemh_uj', '_blank', 'noopener,noreferrer')}
                                className="flex flex-row justify-center items-center px-[25.2671px] py-[10.8288px] gap-[7.22px] w-fit h-[43.66px] border-[0.72px] rounded-[12px] text-white text-center font-[600] text-[12.9945px] leading-[22px] transition-all duration-300 hover:scale-105 mx-auto md:mx-0"
                                style={{
                                    background: 'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                                    borderColor: 'rgba(40, 227, 218, 0.25)',
                                    fontFamily: 'Inter, sans-serif'
                                }}
                                aria-label="تابعنا على إكس"

                            >
                            تابعنا على إكس
               </button>


                        </div>

                        {                                         }
                        <div className="hidden md:grid md:grid-cols-3 gap-8 md:col-span-3">
                            {                           }
                            <div className="text-right">
                                <h3 className="text-lg font-bold mb-4 text-white text-left">الروابط الرئيسية</h3>
                                <ul className="space-y-3">
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => navigate('/')}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الرئيسية
                                        </button>
                                    </li>
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => setShowEvaluationModal(true)}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            التقييم
                                        </button>
                                    </li>
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => setShowCalculatorModal(true)}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الحاسبة
                                        </button>
                                    </li>
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => navigate('/services')}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الخدمات الالكترونية
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            {                                   }
                            <div className="text-right">
                                <h3 className="text-lg font-bold mb-4 text-white text-left">تابعنا</h3>
                                <ul className="space-y-3">

                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <a href="https://x.com/Hemh_uj" className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300">إكس</a>
                                    </li>
                                </ul>
                            </div>

                            {                            }
                            <div className="text-right">
                                <h3 className="text-lg font-bold mb-4 text-white text-left">معلومات عن همة</h3>
                                <ul className="space-y-3">
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => navigate('/about')}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            حول همة
                                        </button>
                                    </li>
                                    <li className="flex items-center">
                                        <div className="w-2 h-2 bg-[#28e3da] rounded-full ml-3"></div>
                                        <button
                                            onClick={() => navigate('/terms')}
                                            className="text-base text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            Privacy Policy
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {                                                   }
                    <div className="md:hidden mb-6">
                        <div className="grid grid-cols-3 gap-6">
                            {                }
                            <div className="text-center">
                                <h3 className="text-sm md:text-base font-bold mb-2 md:mb-3 text-white text-center">الروابط الرئيسية</h3>
                                <ul className="space-y-1 md:space-y-2">
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => navigate('/')}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الرئيسية
                                        </button>
                                    </li>
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => setShowEvaluationModal(true)}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            التقييم
                                        </button>
                                    </li>
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => setShowCalculatorModal(true)}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الحاسبة
                                        </button>
                                    </li>
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => navigate('/services')}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            الخدمات
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            {                  }
                            <div className="text-center">
                                <h3 className="text-sm md:text-base font-bold mb-2 md:mb-3 text-white text-center">تابعنا</h3>
                                <ul className="space-y-1 md:space-y-2">
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <a href="https://x.com/Hemh_uj" className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300">إكس </a>
                                    </li>
                                </ul>
                            </div>

                            {           }
                            <div className="text-center">
                                <h3 className="text-sm md:text-base font-bold mb-2 md:mb-3 text-white text-center">معلومات همة</h3>
                                <ul className="space-y-1 md:space-y-2">
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => navigate('/about')}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            حول همة
                                        </button>
                                    </li>
                                    <li className="flex justify-center items-center">
                                        <div className="w-1 h-1 md:w-1.5 md:h-1.5 bg-[#28e3da] rounded-full ml-1 md:ml-2"></div>
                                        <button
                                            onClick={() => navigate('/terms')}
                                            className="text-xs md:text-sm text-gray-300 hover:text-[#28e3da] transition-colors duration-300 cursor-pointer"
                                        >
                                            Privacy Policy
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {                                              }
                    <div className="border-t border-gray-600 pt-3 md:pt-6">
                        <div className="text-center md:text-right">
                            <p className="text-xs md:text-sm text-gray-400">
                                جميع الحقوق محفوظة @ همة 2025
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;